import { Form, Button, Col, Row, InputGroup, Modal } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import React, { useEffect, useState, useLocation } from 'react';

import InfoTooltip from '../../core/ToolTip';
import { FaInfoCircle } from 'react-icons/fa';
import axios from "axios";
import { useSearchParams, useNavigate, useParams } from 'react-router-dom';
import { SpinnerModal, generateYears, getFiscalYear } from '../Util';

export default function VisitationResponse() {

    const VISITATION_BASE_URL = process.env.REACT_APP_VISITATION_BASE_URL;
    const VISITATION_GET_ID = process.env.REACT_APP_VISITATION_GET_ID;
    const VISITATION_PUT = process.env.REACT_APP_VISITATION_PUT;
    const VISITATION_POST = process.env.REACT_APP_VISITATION_POST;

    const years = generateYears(2020, new Date().getFullYear());
    const data = {
        type: "VISITATION",
        createdBy: "", // user
        updateddBy: "", // updated user
        status: "",
        createdDate: "",
        updatedDate: "",
        siteName: "",
        year: "",
        month: "",
        fiscalYear: "",
        visitation: {
            totalVisitation: 0,
            paid: {
                generalVisitors: "",
                schoolVisitors: "",
                outOfStateVisitors: "",
                paidOutreachOffsiteVirtual: "",
                totalPaid: 0
            },
            unpaid: {
                complimentary: "",
                recreational: "",
                otherNonTicketed: "",
                outreachOffsiteVirtual: "",
                totalUnpaid: 0
            }
        },
        revenue: {
            totalVisitationRevenue: "",
            phmcTotalRevenue: "",
            phmcAdmissionShare: "",
            phmcAdmissionSharePercent: "",
            associateAdmissionShare: "",
            associateAdmissionSharePercent: "",
            totalAdmissionsRevenue: ""
        },
        combo: {
            tixSold: "",
            tixRecv: "",
            tixIncome: ""
        },
        eventsAdmissions: {
            visitorsPaid: "",
            visitorsUnPaid: "",
            totalEventRevenue: ""
        },
        remarks: "",
        acknowledge: false
    }


    const [userRole, setUserRole] = useState(null);
    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        if (storedUser) {
            const profile = JSON.parse(storedUser);
            setUserRole(profile.role);
        }
    }, []);
    const [isPartnerProperty, setPartnerProperty] = useState(false);

    const [formData, setFormData] = useState(data);
    let [searchParams] = useSearchParams();
    let { id } = useParams();
    useEffect(() => {
        const recordId = id;//searchParams.get('id');
        console.log(recordId);
        if (recordId) {
            const url = VISITATION_BASE_URL + recordId + VISITATION_GET_ID;
            console.log(url);
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    setFormData(data);
                    if (formData.siteName === 'RAILROAD MUSEUM') {
                        setPartnerProperty(true);
                    } else {
                        setPartnerProperty(false);
                    }
                })
        }
    }, []);


    const navigate = useNavigate();

    const [saveShow, setSaveShow] = useState(false);
    const handleClose = () => setSaveShow(false);
    const handleShow = () => setSaveShow(true);

    const handleApprove = (e) => {
        if (formData.status === "SUBMITTED") {
            formData.status = "APPROVED";
            handleSubmit(e);
        } else {
            handleShow();
        }
    };
    const handleReject = (e) => {
        if (formData.status === "SUBMITTED") {
            formData.status = "REJECTED";
            handleSubmit(e);
        } else {
            handleShow();
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const url = VISITATION_BASE_URL + formData._id + VISITATION_PUT;
        // Call REST API to store the data
        axios.put(url, formData
        ).then((response) => {
            console.log(response.status, response.data);
            setFormData(data);
            navigate("/visitationView");
        }).catch((error) => {
            console.log(error);
        });


    }


    return (
        <>

            <Modal
                show={saveShow}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}>
                <Modal.Header >
                    <Modal.Title>Warning!!!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    OOPS!!! The record you have selected is not in Submitted Status to Approve/Reject.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>
            <span ><b>Visitation</b> </span>

            <div className="main-content">
                <Form className="main-content"  >
                    <Row className="mb-0 main-content">
                        <Form.Group as={Col} controlId="sitename" >
                            <Form.Label>SiteName</Form.Label>
                            <Form.Select defaultValue="" name="siteName" value={formData.siteName} disabled>
                                <option value="">Select</option>
                                <option>ANTHRACITE HERITAGE</option>
                                <option>BRANDYWINE BATTLEFIELD</option>
                                <option>BUSHY </option>
                                <option>CONRAD W</option>
                                <option>CORNWALL</option>
                                <option>DANIEL B</option>
                                <option>DRAKE WELL</option>
                                <option>ECKLEY MINERS' VLGE</option>
                                <option>EPHRATA CLOISTER</option>
                                <option>ERIE MARITIME</option>
                                <option>FORT PITT</option>
                                <option>GRAEME </option>
                                <option>HOPE</option>
                                <option>JOSEPH P</option>
                                <option>LANDIS VALLEY</option>
                                <option>OLD ECONOMY</option>
                                <option>PENNSBURY</option>
                                <option>PA LUMBER MUSEUM</option>
                                <option>PA MILITARY MUSEUM</option>
                                <option>RAILROAD MUSEUM</option>
                                <option>SOMERSET</option>
                            </Form.Select>

                        </Form.Group>

                        <Form.Group as={Col} controlId="year">
                            <Form.Label>Year</Form.Label>
                            <Form.Select defaultValue="" name="year" required value={formData.year} disabled>
                                <option value="">Select</option>
                                {years.map(year => (
                                    <option key={year} value={year}>{year}</option>
                                ))}

                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Col} controlId="month">
                            <Form.Label>Month</Form.Label>
                            <Form.Select defaultValue="" name="month" value={formData.month} disabled >
                                <option value="">Select</option>
                                <option>JANUARY</option>
                                <option>FEBRAURY</option>
                                <option>MARCH</option>
                                <option>APRIL</option>
                                <option>MAY</option>
                                <option>JUNE</option>
                                <option>JULY</option>
                                <option>AUGUST</option>
                                <option>SEPTEMBER</option>
                                <option>OCTOBER</option>
                                <option>NOVEMBER</option>
                                <option>DECEMBER</option>
                            </Form.Select>
                        </Form.Group>
                    </Row>

                    {/* General Admission Data Entry */}
                    <Row className="mb-0 main-content" >
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Paid Visitation</Card.Title>
                                    <Row className="mb-0 main-content" >
                                        <Form.Group as={Col} controlId="generalvisitors">
                                            <InfoTooltip label={'General Visitors and Group/Bus Tours'} placement={"right"}>
                                                <Form.Label> General Visitors <FaInfoCircle /></Form.Label>
                                            </InfoTooltip>
                                            <Form.Control type="number" placeholder="0" name="visitation.paid.generalVisitors" value={formData.visitation?.paid?.generalVisitors} disabled />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter General Visitors.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="schoolvisitors">
                                            <Form.Label>School Visitors</Form.Label>
                                            <Form.Control type="number" placeholder="0" name="visitation.paid.schoolVisitors" value={formData.visitation?.paid?.schoolVisitors} disabled />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter School Visitors.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-0 main-content" >
                                        <Form.Group as={Col} controlId="outofstatevisitors">
                                            <Form.Label>Out of state Visitors</Form.Label>
                                            <Form.Control type="number" placeholder="0" name="visitation.paid.outOfStateVisitors" value={formData.visitation?.paid?.outOfStateVisitors} disabled />
                                            <Form.Control.Feedback type="invalid">
                                                Please enter Out Of State Visitors.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Col />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            {/* Un Paid  Data Entry */}
                            <Card>
                                <Card.Body>
                                    <Card.Title>Un-Paid Visitation</Card.Title>
                                    <Row className="mb-0 main-content" >
                                        <Form.Group as={Col} controlId="complimentary">
                                            <Form.Label>Complimentary</Form.Label>
                                            <Form.Control name="visitation.unpaid.complimentary" type="number" placeholder="0" value={formData.visitation?.unpaid?.complimentary} disabled />

                                        </Form.Group>

                                        <Form.Group as={Col} controlId="recreational">
                                            <Form.Label>Recreational</Form.Label>
                                            <Form.Control type="number" placeholder="0" name="visitation.unpaid.recreational" value={formData.visitation?.unpaid?.recreational} disabled />
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-0 main-content" >
                                        <Form.Group as={Col} controlId="othernonticketed">
                                            <Form.Label>Other Non-ticketed</Form.Label>
                                            <Form.Control name="visitation.unpaid.otherNonTicketed" type="number" placeholder="0" value={formData.visitation?.unpaid?.otherNonTicketed} disabled />
                                        </Form.Group>
                                        <Col />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Total Visitation</Card.Title>
                                    <Row className="mb-3 main-content" >
                                        <Form.Group as={Col} controlId="totalpaid">
                                            <Form.Label>Total Paid</Form.Label>
                                            <Form.Control type="number" name="visitation.paid.totalPaid" value={formData.visitation?.paid?.totalPaid} disabled />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="totalUnpaid">
                                            <Form.Label>Total UnPaid</Form.Label>
                                            <Form.Control type="number" name="visitation.unpaid.totalUnpaid" value={formData.visitation?.unpaid?.totalUnpaid} disabled />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="total">
                                            <Form.Label>Total Visitation</Form.Label>
                                            <Form.Control type="number" name="visitation.total" value={formData.visitation?.totalVisitation} disabled />
                                        </Form.Group>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {/* Revenue Entry */}

                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Revenue</Card.Title>
                                    <Row className="mb-3 main-content" >
                                        <Form.Group as={Col} controlId="totalAdmissionsRevenue">
                                            <Form.Label>Total Admissions Revenue</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="revenue.totalAdmissionsRevenue" disabled value={formData.revenue?.totalAdmissionsRevenue} />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="phmcAdmissionShare">
                                            <Form.Label>PHMC Admissions Percent Split</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>%</InputGroup.Text>
                                                <Form.Control type="number" name="revenue.phmcAdmissionSharePercent" disabled value={formData.revenue?.phmcAdmissionSharePercent} />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="phmcAdmissionShare">
                                            <Form.Label>Associate Admissions Percent Split</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>%</InputGroup.Text>
                                                <Form.Control type="number" name="revenue.associateAdmissionSharePercent" disabled value={formData.revenue?.associateAdmissionSharePercent} />
                                            </InputGroup>
                                        </Form.Group>

                                    </Row>
                                    <Row className="mb-3 main-content">
                                        <Form.Group as={Col} controlId="phmcAdmissionShare">
                                            <Form.Label>PHMC Admissions Share</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="revenue.phmcAdmissionShare" disabled value={formData.revenue?.phmcAdmissionShare} />
                                            </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="associateAdmissionShare">
                                            <Form.Label>Associate Admissions Share</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text>$</InputGroup.Text>
                                                <Form.Control type="number" name="revenue.associateAdmissionShare" disabled value={formData.revenue?.associateAdmissionShare} />
                                            </InputGroup>
                                        </Form.Group>
                                        <Col />
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {/* TODO: if Partner Property site then hide RR combo and outreach */}
                    {/* RR combo Entry */}
                    {
                        isPartnerProperty ? (
                            <Row className="mb-0 main-content">
                                <Col>
                                    <Card>
                                        <Card.Body>
                                            <Card.Title>RR Combo</Card.Title>
                                            <Row className="mb-3 main-content" >
                                                <Form.Group as={Col} controlId="combotixsold">
                                                    <Form.Label>RR Combo TIX Sold</Form.Label>
                                                    <Form.Control type="number" placeholder="0" name="combo.tixSold" value={formData.combo?.tixSold} disabled />
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="combotixrecv">
                                                    <Form.Label>RR Combo TIX RECV</Form.Label>
                                                    <Form.Control name="combo.tixRecv" type="number" placeholder="0" value={formData.combo?.tixRecv} disabled />
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="tixIncome">
                                                    <Form.Label>Combo TIX Income</Form.Label>
                                                    <InputGroup className="mb-3">
                                                        <InputGroup.Text>$</InputGroup.Text>
                                                        <Form.Control disabled type="number" name="combo.tixIncome" value={formData.combo?.tixIncome} readOnly />
                                                    </InputGroup>
                                                </Form.Group>

                                            </Row>
                                            <Row className="mb-3 main-content" >
                                                <Col />
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                                <Col>
                                    {/* Outreach Program Entry */}
                                    <Card>
                                        <Card.Body>
                                            <Card.Title>Outreach Program</Card.Title>
                                            <Row className="mb-3 main-content" >
                                                <Form.Group as={Col} controlId="offsitevirtualyouth">
                                                    <Form.Label>Offsite Or Virtual for Schools/Youth </Form.Label>
                                                    <Form.Control name="outreach.offsiteOrVirtualYouth" type="number" placeholder="0" value={formData.outreach?.offsiteOrVirtualYouth} disabled />
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="offsitevirtualadult">
                                                    <Form.Label>Offsite Or Virtual for Adult</Form.Label>
                                                    <Form.Control name="outreach.offsiteOrVirtualAdult" type="number" placeholder="0" value={formData.outreach?.offsiteOrVirtualAdult} disabled />
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-3 main-content" >
                                                <Form.Group as={Col} controlId="virtualProgRevenue">
                                                    <Form.Label>Virtual Prog Revenue</Form.Label>
                                                    <InputGroup className="mb-3">
                                                        <InputGroup.Text>$</InputGroup.Text>
                                                        <Form.Control disabled type="number" name="outreach.virtualProgRevenue" value={formData.outreach?.virtualProgRevenue} readOnly />
                                                    </InputGroup>
                                                </Form.Group>
                                                <Form.Group as={Col} controlId="virtualPhmcRevenue">
                                                    <Form.Label>Virtual PHMC Revenue</Form.Label>
                                                    <InputGroup className="mb-3">
                                                        <InputGroup.Text>$</InputGroup.Text>
                                                        <Form.Control disabled type="number" name="outreach.virtualPhmcRevenue" value={formData.outreach?.virtualPhmcRevenue} readOnly />
                                                    </InputGroup>
                                                </Form.Group>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        ) : (<div />)}
                    {/* Associate/Partner Events  */}
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Associate / Partner Property Events</Card.Title>
                                    <Row className="mb-3 main-content" >
                                        <Form.Group as={Col} controlId="eventsvisitorspaid">
                                            <Form.Label>Associate Event Visitors Paid</Form.Label>
                                            <Form.Control name="eventsAdmissions.visitorsPaid" type="number" placeholder="0" value={formData.eventsAdmissions?.visitorsPaid} disabled />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="eventsvisitorsunpaid">
                                            <Form.Label>Associate Event Visitors Unpaid</Form.Label>
                                            <Form.Control name="eventsAdmissions.visitorsUnPaid" type="number" placeholder="0" value={formData.eventsAdmissions?.visitorsUnPaid} disabled />
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="totalEventRevenue">
                                            <Form.Label>Total Associate Event Revenue</Form.Label>
                                            <Form.Control name="eventsAdmissions.totalEventRevenue" type="number" placeholder="0" value={formData.eventsAdmissions?.totalEventRevenue} disabled />
                                        </Form.Group>
                                    </Row>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="mb-0 main-content">
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Card.Title>Remarks</Card.Title>
                                    <Form.Group as={Col} controlId="remarks">
                                        <InputGroup>
                                            <Form.Control as="textarea" aria-label="Remarks" required name="remarks" value={formData.remarks} disabled />
                                        </InputGroup>
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    {userRole && userRole !== 'OBSERVER' &&
                        <Form.Group>

                            <Row className="mb-3 main-content">
                                <Col>
                                    <Row className="mb-3 submit">
                                        {formData.status !== 'APPROVED' && (
                                            <Col>
                                                <Button variant="primary" onClick={handleApprove}>Approve</Button>
                                            </Col>
                                        )}
                                        <Col>
                                            <Button variant="secondary" onClick={handleReject}> Reject</Button>
                                        </Col>
                                        <Col /></Row>

                                </Col>
                                <Col />

                                <Col />
                                <Col />
                                <Col />
                            </Row>
                        </Form.Group>
                    }
                </Form>
            </div>
        </>
    );
}